import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AccountingService } from './accounting.service';
import { ModalCancelNoteComponent } from './modal-Cancel-note/modal-Cancel-note.component';
import { ModalCancelComponent } from './modal-Cancel/modal-Cancel.component';
import { ModalDetailInstallmentComponent } from './modal-detail-installment/modal-detail-installment.component';
import * as moment from 'moment';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.scss']
})
export class AccountingComponent implements OnInit {

  tableName: string = 'quotation';
  column = [];
  search: string;
  isSearch: boolean = false;
  allPayment = [];
  listOfData = [];
  isLoading: boolean = false;
  type: string = '';

  account = [];
  quotationList = [];
  bankAccount: string = 'All';

  filterStatus = [
    { text: 'สำเร็จ', value: 'Done' },
    { text: 'รอชำระ', value: 'Wait' },
    { text: 'ไม่สำเร็จ', value: 'Cancel' },
  ];

  filterQuotationStatus = [
    { text: 'สำเร็จ', value: 'Done' },
    { text: 'รอดำเนินการ', value: 'Wait' },
    { text: 'แบ่งจ่าย', value: 'Partial' },
    { text: 'ยกเลิก', value: 'Cancel' },
  ];

  filterReceiptStatus = [
    { text: 'สำเร็จ', value: 'Done' },
    { text: 'ยกเลิก', value: 'Cancel' },
  ];

  filterType = [
    { text: 'บริษัท', value: 'บริษัท' },
    { text: 'ส่วนบุคคล', value: 'ส่วนบุคคล' },
  ];

  statusFilterFn = (list: string[], item) => list.some(status => item.STATUS.indexOf(status) !== -1);
  typeFilterFn = (list: string[], item) => list.some(type => item.CUSTOMER_TYPE.indexOf(type) !== -1);

  // quotation
  sortQuotationDateFn = (a, b) => moment(a.QUOTATION_START).unix() - moment(b.QUOTATION_START).unix();
  sortQuotationNoFn = (a, b) => a.QUOTATION_NO.localeCompare(b.QUOTATION_NO);
  sortTotalFn = (a, b) => a.TOTAL_PRICE - b.TOTAL_PRICE;

  // invoice
  sortInvoiceNoFn = (a, b) => a.INVOICE_NO.localeCompare(b.INVOICE_NO);
  sortInvoiceDateFn = (a, b) => moment(a.INVOICE_START).unix() - moment(b.INVOICE_START).unix();
  sortInvoiceDateEndFn = (a, b) => moment(a.INVOICE_END).unix() - moment(b.INVOICE_END).unix();
  sortInvTotalFn = (a, b) => a.TOTAL - b.TOTAL;

  // receipt
  sortInvoiceNoRecFn = (a, b) => { a = a.INVOICE_NO || ''; b = b.INVOICE_NO || ''; return a.localeCompare(b) };
  sortReceiptNoFn = (a, b) => a.RECEIPT_NO.localeCompare(b.RECEIPT_NO);
  sortReceiptDateFn = (a, b) => moment(a.CREATE_DATE).unix() - moment(b.CREATE_DATE).unix();
  sortRecTotalFn = (a, b) => a.TOTAL - b.TOTAL;

  constructor(
    public matDialog: MatDialog,
    private gobalFunctionService: GobalFunctionService,
    private accountService: AccountingService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setTitle('Accounting');
    this.type = new URL(location.href).searchParams.get('type');
    if (this.type) { this.tableName = this.type; }

    this.accountService.getActiveAccount().pipe(
      map(a => {
        // console.log(a.result);
        this.account = a.result;
      })
    ).subscribe();

    this.getAllPayment(this.tableName, this.bankAccount);
  }

  getAllPayment(m, account) {
    this.isLoading = true;
    this.bankAccount = account;
    this.tableName = m;
    this.allPayment = [];
    this.search = '';
    this.isSearch = false;

    this.accountService.getAllAccounting(m, account).pipe(
      map(res => {
        console.log(res.result);
        this.allPayment = res.result;
        this.isLoading = false;
      })
    ).subscribe();
  }

  searching() {
    if (this.search !== '') {
      this.isSearch = true;
      this.listOfData = [];
      this.allPayment.filter(payment => {

        if ((payment.QUOTATION_NO && payment.QUOTATION_NO.toLowerCase().includes(this.search.toLowerCase())) || (payment.CUSTOMER_NAME && payment.CUSTOMER_NAME.toLowerCase().includes(this.search.toLowerCase())) || (payment.RECEIPT_NO && payment.RECEIPT_NO.toLowerCase().includes(this.search.toLowerCase())) || (payment.INVOICE_NO && payment.INVOICE_NO.toLowerCase().includes(this.search.toLowerCase()))) {
          this.listOfData.push(payment)
        }
      });
      // console.log(this.listOfData);

    } else {
      this.isSearch = false;
      this.listOfData = null;
      this.getAllPayment(this.tableName, this.bankAccount);
    }
  }

  detailPartial(id, ver) {
    const dialogConfig = new MatDialogConfig();

    this.accountService.getDetailPartial(id, ver).pipe(
      switchMap(res => {
        if (res.success) {
          dialogConfig.disableClose = true;
          dialogConfig.id = 'modalConfirm';
          dialogConfig.width = '800px';
          dialogConfig.autoFocus = false;
          dialogConfig.data = {
            detail: res.result,
          }

          const modal = this.matDialog.open(ModalDetailInstallmentComponent, dialogConfig);
          return modal.afterClosed().pipe(
            map(res1 => {
              // console.log(res1);
            })
          )
        }
      }),
      catchError(err => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(false)
      })
    ).subscribe();

  }

  cancelQuotation(id, type, ver) {
    this.isLoading = true;
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: type
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            QUOTATION_NO: id,
            QUOTATION_VERSION: ver,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelQuotation(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบเสนอราคาสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      location.reload();
                    }
                  })
                )
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  cancelInvoice(id, type) {
    this.isLoading = true;
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: type
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            INVOICE_NO: id,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelInvoice(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบแจ้งหนี้สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      location.reload();
                    }
                  })
                )
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  cancelReceipt(id, type) {
    this.isLoading = true;
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: type
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            RECEIPT_NO: id,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelReceipt(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      location.reload();
                    }
                  })
                )
              }
            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  cancelNote(id, remark, type, ver) {
    this.isLoading = true;
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      remark: remark
    }
    const modal = this.matDialog.open(ModalCancelNoteComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        // console.log(res);
        if (res.status) {
          this.isLoading = false;
          if (type === 'quotation') {

            body = {
              QUOTATION_NO: id,
              QUOTATION_VERSION: ver,
              CANCEL_REMARK: res.value,
            }

            return this.accountService.cancelQuotation(body).pipe(
              switchMap(res1 => {
                if (res1.success) {
                  const dialogConfig1 = new MatDialogConfig();
                  dialogConfig1.disableClose = true;
                  dialogConfig1.id = 'modalConfirm';
                  dialogConfig1.width = '400px';
                  dialogConfig1.data = {
                    title: 'สำเร็จแล้ว',
                    description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกสำเร็จแล้ว`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B;'
                  }

                  const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                  return modal2.afterClosed().pipe(
                    map(res2 => {
                      // console.log(res2);
                      if (!res2) {
                        this.isLoading = false;
                        location.reload();
                      }
                    })
                  )
                }
              })
            )

          } else if (type === 'invoice') {
            body = {
              INVOICE_NO: id,
              CANCEL_REMARK: res.value,
            }

            return this.accountService.cancelInvoice(body).pipe(
              switchMap(res1 => {
                if (res1.success) {
                  const dialogConfig1 = new MatDialogConfig();
                  dialogConfig1.disableClose = true;
                  dialogConfig1.id = 'modalConfirm';
                  dialogConfig1.width = '400px';
                  dialogConfig1.data = {
                    title: 'สำเร็จแล้ว',
                    description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกสำเร็จแล้ว`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B;'
                  }

                  const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                  return modal2.afterClosed().pipe(
                    map(res2 => {
                      // console.log(res2);
                      if (!res2) {
                        this.isLoading = false;
                        location.reload();
                      }
                    })
                  )
                }
              })
            )

          } else if (type === 'receipt') {
            body = {
              RECEIPT_NO: id,
              CANCEL_REMARK: res.value,
            }

            return this.accountService.cancelReceipt(body).pipe(
              switchMap(res1 => {
                if (res1.success) {
                  const dialogConfig1 = new MatDialogConfig();
                  dialogConfig1.disableClose = true;
                  dialogConfig1.id = 'modalConfirm';
                  dialogConfig1.width = '400px';
                  dialogConfig1.data = {
                    title: 'สำเร็จแล้ว',
                    description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกสำเร็จแล้ว`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B;'
                  }

                  const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                  return modal2.afterClosed().pipe(
                    map(res2 => {
                      // console.log(res2);
                      if (!res2) {
                        this.isLoading = false;
                        location.reload();
                      }
                    })
                  )
                }
              })
            )
          }

        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError(err => {
        this.isLoading = false;
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  createQuotation() {
    window.open('/accounting/create-quotation?isEdit=false', '_blank');
  }

  editQuotation(id, version) {
    window.open(`/accounting/create-quotation?isEdit=true&id=${id}&version=${version}`, '_blank');
  }

  createInvoiceByID(id, ver) {
    window.open(`/accounting/create-invoice?isEdit=false&id=${id}&version=${ver}`, '_blank');
  }

  PartialInvoice(id, ver) {
    window.open(`/accounting/create-invoice?isEdit=false&id=${id}&Partial=true&version=${ver}`, '_blank');
  }

  createReceiptFromInvoice(id) {
    window.open(`/accounting/create-receipt-from-invoice?isEdit=false&id=${id}`, '_blank');
  }

  createPersonalReceipt() {
    window.open('/accounting/create-personal-receipt?isEdit=false', '_blank');
  }

  editInvoice(id, type, ver) {
    if (type === 'Partial') {
      window.open(`/accounting/create-invoice?isEdit=true&id=${id}&Partial=true&version=${ver}`, '_blank');
    } else {
      window.open(`/accounting/create-invoice?isEdit=true&id=${id}`, '_blank');
    }
  }

  editReceipt(id, type, customer) {
    if (customer === 'บริษัท') {
      window.open(`/accounting/create-receipt-from-invoice?isEdit=true&id=${id}&type=${type}`, '_blank');
    } else if (customer === 'ส่วนบุคคล') {
      // } else {
      window.open(`/accounting/create-personal-receipt?isEdit=true&id=${id}&type=${type}`, '_blank');
    }
  }

  editPersonalReceipt(id) {
    window.open(`/accounting/create-personal-receipt?isEdit=true&id=${id}`, '_blank');
  }

}
